import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { Snackbar as Snack, IconButton } from "@mui/material";

// @mui/icons-material
import Close from "@mui/icons-material/Close";
// core components
import styles from "../../assets/jss/material-dashboard-react/components/snackbarContentStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";

export default function Snackbar(props) {

  const { message, color, close, icon, place, open, rtlActive } = props;
  var action = [];

  const messageData = {
    "iconMessage": icon !== undefined
  }

  const messagesKeys = getKeyArray(messageData);

  const actionRtlData = {
    actionRTL: rtlActive
  };

  const actionRtlKeys = getKeyArray(actionRtlData);



  if (close !== undefined) {
    action = [
      <IconButton
        sx={styles.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={() => props.closeNotification()}
      >
        <Close sx={styles.close} />
      </IconButton>
    ];
  }
  return (

    <Snack
      anchorOrigin={{
        vertical: place.indexOf("t") === -1 ? "bottom" : "top",
        horizontal:
          place.indexOf("l") !== -1
            ? "left"
            : place.indexOf("c") !== -1
              ? "center"
              : "right"
      }}
      open={open}
      message={
        <div>
          {icon !== undefined ? <props.icon sx={getBaseSxStyle(styles, ['icon'])} /> : null}
          <span styles={getBaseSxStyle(styles, [...messagesKeys])}>
            {message}
          </span>
        </div>
      }
      action={action}
      ContentProps={{
        sx: getBaseSxStyle(styles, ['root', color, 'message', ...actionRtlKeys]),
      }}
    />
  );
}

Snackbar.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.object,
  place: PropTypes.oneOf(["tl", "tr", "tc", "br", "bl", "bc"]),
  open: PropTypes.bool,
  rtlActive: PropTypes.bool,
  closeNotification: PropTypes.func
};
